import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetGroup: {
    ...theme.mixins.appContainer,
    padding: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.5),
    },
  },
  setGroupHeader: {
    padding: theme.spacing(1, 1, 0.5),
  },
}));
